const hosts = [
    'phio',
    'staging',
    'test',
    'covid19',
    'circlehealth',
    'healthshare',
    'connecthealth',
    'demo',
];

const hostedDomainsRegex = new RegExp(`${hosts.join('|')}`);
const localHostRegex = /localhost/;
const localMacRegex = /localmac/; // used for testing in virtual machines
const ipRegex = /[\d]{1,3}.[\d]{1,3}.[\d]{1,3}.[\d]{1,3}:3000/;
const stagingRegex = /staging/;
const playgroundRegex = /playground|bright-vibes/;

export const isLocalHost = () => {
    const hostName = window.location.hostname;

    return (
        hostName.match(localHostRegex) ||
        hostName.match(localMacRegex) ||
        hostName.match(ipRegex)
    );
};

export const isStaging = () => {
    const hostName = window.location.hostname;
    return stagingRegex.test(hostName);
};

export const isHosted = () => {
    const hostName = window.location.hostname;
    return hostedDomainsRegex.test(hostName);
};

export const getHostName = () => {
    const hostName = window.location.hostname;
    return hostName.match(hostedDomainsRegex);
};

export const isPlayground = () => {
    const hostName = window.location.hostname;
    return playgroundRegex.test(hostName);
};

export const isTestingEnv = () => {
    const hostName = window.location.hostname;
    return /test/.test(hostName);
};

export const isProductionEnv = () => {
    const hostName = window.location.hostname;
    return hostName.match(/phio.eql.ai/);
};

export const isDev = () => {
    return isLocalHost() || isPlayground() || isStaging() || isTestingEnv();
};

export const getEnvName = () => {
    let envName = '';

    if (isLocalHost()) {
        envName = 'Localhost';
    }
    if (isTestingEnv()) {
        envName = 'Testing';
    }
    if (isPlayground()) {
        envName = 'Playground';
    }
    if (isStaging()) {
        envName = 'Staging';
    }
    if (isProductionEnv()) {
        envName = 'Production';
    }

    return envName;
};
